module.exports = __webpack_public_path__ + "static/img/c2.5dae3aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui3/c2.png
// module id = WkSO
// module chunks = 1